// メッセージMap
export const MessageMap = {
    "coordinator_id": "請求先",
    "apply_date_start": "請求対象年月（From）",
    "apply_date_end": "請求対象年月（To）",
    "billing_date_ym": "請求対象年月",
};